<body>
<mat-card class="card"> <img class="logo1" src="../../../assets/img/flat-lay-photography-of-vegetable-salad-on-plate-1640777.jpg">
    <form class="main" [formGroup]="addForm" (ngSubmit)="verify(addForm.value)">
       
            <span class="title">Forget Password?</span>
            <span></span>

            <div class="row">
                <mat-form-field  class=""><mat-label>Phone Number</mat-label>
                    <input  matInput placeholder="Phone" formControlName="phone" name="phone"></mat-form-field> 
                    <div class="alert" *ngIf="!addForm.controls['phone'].valid && addForm.controls['phone'].touched">{{msg}}
                    </div>
            </div>
            <div class="row1">
                    <button  mat-button class="btn1">Send OTP</button>
           
            </div>
        

        </form>    
    </mat-card>
</body>